import { Link } from 'react-router-dom';
import { Nav, Container, Navbar as BsNavbar } from 'react-bootstrap';

import UserDropdown from './UserDropdown';
import { useAuth } from 'src/AuthContext';
import { ACCOUNT_TYPE } from 'src/constants/authConstants';

export default function Navbar() {
  const { user } = useAuth();
  const showUserManagement = [
    'shmuelt',
    'yitzn',
    'davidp',
    'saras',
    'devorahs',
    'jeff',
    'jennifert',
    'joe',
    'asommer',
    'ajay',
    'lizr',
    'nevil',
  ].some((prefix) => user.email.startsWith(prefix));
  const logoUrl = () => {
    if (user?.accountType === ACCOUNT_TYPE.ALCOVE) {
      return '/assets/logo/alcove-icon.png';
    }
    if (user?.accountName === 'PRO Department') {
      return '/assets/logo/modular-logo.svg';
    }
    return '/assets/logo/logo.svg';
  };

  const showAutoRender = user.accountType === ACCOUNT_TYPE.MULTIFAMILY;

  return (
    <BsNavbar
      style={{
        background: 'white',
        position: 'sticky',
        top: 0.25,
        zIndex: 1000,
        borderBottom: '1px solid #9CA3AF33',
      }}
      expand='sm'
    >
      <Container className='d-flex'>
        <BsNavbar.Brand>
          <Link to='/' id='logo-full' style={{ textDecoration: 'none' }}>
            <img
              src={logoUrl()}
              alt='Company Logo'
              style={{
                height:
                  user?.accountType === ACCOUNT_TYPE.ALCOVE
                    ? '100%'
                    : user?.accountName === 'PRO Department'
                      ? '3rem'
                      : '3.375rem',
                width:
                  user?.accountType === ACCOUNT_TYPE.ALCOVE
                    ? '11rem'
                    : user?.accountName === 'PRO Department'
                      ? '9.625rem'
                      : '11rem',
              }}
            />
          </Link>
        </BsNavbar.Brand>

        <BsNavbar.Toggle aria-controls='basic-navbar-nav' />
        <BsNavbar.Collapse id='basic-navbar-nav' className='justify-content-end'>
          <Nav>
            {showAutoRender && (
              <Nav.Link as={Link} to='/auto-render' style={{ marginRight: '20px' }}>
                Auto Render
              </Nav.Link>
            )}
            {showAutoRender && (
              <Nav.Link as={Link} to='/tax' style={{ marginRight: '20px' }}>
                Tax Dashboard
              </Nav.Link>
            )}
            {showUserManagement && (
              <Nav.Link as={Link} to='/admin/users' style={{ marginRight: '20px' }}>
                User Management
              </Nav.Link>
            )}
            <UserDropdown />
          </Nav>
        </BsNavbar.Collapse>
      </Container>
    </BsNavbar>
  );
}
